import React, { Component } from "react";
import {
    Container,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
import { isAuthenticated } from "../auth";
import { Redirect } from "react-router-dom";

class Admin extends Component {

    constructor() {
        super();
        this.state = {
            groups: [],
            userId: isAuthenticated() && isAuthenticated().userId,
            username: isAuthenticated() && isAuthenticated().name,
            token: isAuthenticated().token,
            userEmail: isAuthenticated().email,
            redirectToHome: false
        };
    }

    componentDidMount() {
        if (isAuthenticated().role !== "admin") {
            this.setState({ redirectToHome: true });
        }
    }

    render() {
        if (this.state.redirectToHome) {
            return <Redirect to="/" />;
        }

        return (
            <Container>
                <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, mt: 3, mb: 4, backgroundColor: '#245aa6', color: 'white', borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Admin Dashboard
                    </Typography>
                    <Typography variant="h6">
                        Welcome Administrator: <strong>{this.state.username}</strong>
                    </Typography>
                </Paper>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>
                            You are listed as Admin on:
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemText primary="Physical" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Technology" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Leadership" />
                            </ListItem>
                        </List>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>
                            Current Users
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemText primary="Trevor Scullion" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Steve Kaufman" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Shawn Weekly" />
                            </ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}

export default Admin;